import React, { Component } from 'react';
import { selectResources, selectContactDate, selectOpeningTimes } from '../store/selectors';
import { setContactDateAction } from '../store/actions';
import { connect } from 'react-redux';
import { formatDate, getHolidays } from '../lib';
import { addMonths } from 'date-fns';
import { FormGroup, Label, memoizeOne } from 'migration-flos-react';

class DateField extends Component {
    startDate = formatDate(new Date());
    endDate = formatDate(addMonths(new Date(), 1));
    contactDateField = React.createRef();

    setContactdate = (event) => {
        if (event.detail.event === 'onChange') {
            this.props.setDateForContact(event.detail.value);
        }
    };

    parseHolidays = memoizeOne((holidays) => JSON.stringify(getHolidays(holidays)));

    componentDidMount() {
        this.contactDateField.current.addEventListener('fieldEvent', this.setContactdate);
    }

    componentWillUnmount() {
        this.contactDateField.current.removeEventListener('fieldEvent', this.setContactdate);
    }

    render() {
        const { section4 } = this.props.resources;
        const holidays = this.props.openTimesObj && this.props.openTimesObj.holidays;
        const holidaysArray = this.parseHolidays(holidays);
        return (
            <FormGroup>
                <Label>{section4.date.label}</Label>
                <flos-date-input
                    change-month="true"
                    min-date={this.startDate}
                    max-date={this.endDate}
                    ref={this.contactDateField}
                    value={this.props.contactDate}
                    no-weekend={true}
                    disabled-dates={holidaysArray}
                />
            </FormGroup>
        );
    }
}

const mapStates = (state) => ({
    resources: selectResources(state),
    contactDate: selectContactDate(state),
    openTimesObj: selectOpeningTimes(state)
});

const mapDispatch = (dispatch) => ({
    setDateForContact: (date) => dispatch(setContactDateAction(date))
});

export default connect(mapStates, mapDispatch)(DateField);
